<template>
  <van-popup class="checkLogin" v-model="isExist">
    <div class="checkLogin-con">
      <p class="checkLogin-title">您当前的账号是</p>
      <p class="checkLogin-phone">{{userInfo.phone || userInfo.name}}</p>
      <div class="checkLogin-btn">
        <div class="checkLogin-btn-left" @click="useSure">继续使用</div>
        <div class="checkLogin-btn-right" @click="changeAcount">更换账号</div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'checkLogin',
  data () {
    return {
      userInfo: {}, // 用户账号信息
      isExist: false // 是否显示弹框
    }
  },
  created () {
    this.$api.checkLogin().then((res) => {
      if (res.stat === 1) {
        this.isExist = true
        this.userInfo = res.data.user_info
      }
    })
  },
  methods: {
    useSure () {
      this.isExist = false
      this.$emit('sureClick')
    },
    changeAcount () {
      this.isExist = false
      this.$emit('changeAcount')
    }
  }
}
</script>
<style lang='scss' scoped>
  .checkLogin {
    background-color: #fff;
    border-radius: 10px;

    &-con {
      width: 283px;
      height: 178px;
      padding-top: 28px;
      font-size: 15px;
      text-align: center;
      color: #333;
    }

    &-phone {
      padding: 30px 0 20px;
      font-size: 24px;
      font-weight: bold;
      letter-spacing: 2px;
    }

    &-btn {
      display: flex;
      height: 46px;
      line-height: 46px;
      border-top: 1px solid #f1f1f1;

      &-left {
        width: 50%;
        color: #666;
      }

      &-right {
        width: 50%;
        color: #f13232;
        border-left: 1px solid #f1f1f1;
      }
    }
  }
</style>
